import { css } from '@emotion/react';

/** App-wide typography and element defaults only */
export const GlobalComponent = css`
  h1,
  h2 {
    margin: 0;
  }

  p {
    small {
      font-size: 0.75em;
    }
  }

  .button.error {
    background-color: red;
    color: white;
  }
`;
